import { render, staticRenderFns } from "./tl-set-driver-card-modal.vue?vue&type=template&id=67b51c2b&"
import script from "./tl-set-driver-card-modal.vue?vue&type=script&lang=js&"
export * from "./tl-set-driver-card-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports